<ng-container [ngTemplateOutlet]="_toolbar"></ng-container>

<ng-template #_toolbar>
  <div class="gameplay__toolbar container d-flex justify-content-between align-items-center ps-sm-2" [style.max-width]="'1024px'">
    <div class="d-flex me-2 me-md-5">
      <ng-container [ngTemplateOutlet]="_left"></ng-container>
    </div>
    <div class="d-flex col">
      <ng-container [ngTemplateOutlet]="_center"></ng-container>
    </div>
    <div class="d-flex ms-2 ms-md-5 align-items-center">
      <ng-container [ngTemplateOutlet]="_right"></ng-container>
    </div>
  </div>
</ng-template>

<!-- navigation -->
<ng-template #_left>
  <ng-container [ngTemplateOutlet]="isStudy ? _pause : _home"></ng-container>
</ng-template>

<ng-template #_center>
  <ng-container [ngTemplateOutlet]="_progressBar"></ng-container>
</ng-template>

<ng-template #_right>
  <ng-container [ngTemplateOutlet]="_volume"></ng-container>
  @if (buttons.length > 0) {
    <ng-container [ngTemplateOutlet]="_devTools"></ng-container>
  }
</ng-template>

<!-- home -->
<ng-template #_home>
  <button button mat-icon-button
    class="col-auto"
    [ngStyle]="{'visibility':toolbar.home?'visible':'hidden'}"
    (click)="onExit()"
    title="Home page" alt="home page"
  >
    <mat-icon aria-hidden="false" aria-label="home" fontIcon="home"></mat-icon>
  </button>
</ng-template>

<!-- home -->
<ng-template #_pause>
  <button mat-icon-button
    class="col-auto"
    [ngStyle]="{'visibility':toolbar.pause?'visible':'hidden'}"
    (click)="onExit()"
    title="pause" alt="pause"
  >
    <mat-icon class="material-icons">pause</mat-icon>
  </button>
</ng-template>

<!-- dev tools -->
<ng-template #_devTools>
  <div class="col-auto mx-0 ps-1 pe-0 align-items-center">
    @for (button of buttons; track $index) {
      <button button mat-icon-button
        class="overflow-hidden"
        (click)="button.action()"
        title="{{button.tooltip()}}"
      >
        <mat-icon [ngClass]="button.class()" aria-hidden="true" fontIcon="{{button.fontIcon}}"></mat-icon>
      </button>
      }
  </div>
</ng-template>

<!-- skip -->
<ng-template #_skip>
  <button mat-icon-button
    class="col-0"
    [ngStyle]="{'visibility':toolbar.skip?'visible':'hidden'}"
    (click)="answer()"
    title="skip question"
  >
    <mat-icon aria-hidden="true" fontIcon="chevron_right"></mat-icon>
  </button>
</ng-template>

<!-- settings -->
<ng-template #_settings>
  <button mat-icon-button
    class="col-0"
    [ngStyle]="{'visibility':toolbar.setting?'visible':'hidden'}"
    (click)="openSettings()"
    title="Preferences"
    data-bs-toggle="modal"
    data-bs-target="#modal"
    data-bs-title="Settings"
  >
    <mat-icon aria-hidden="true" fontIcon="settings"></mat-icon>
  </button>
</ng-template>

<!-- progress bar -->
<ng-template #_progressBar>
  <div class="col mx-1 mx-sm-auto px-0 progressbar__container"
    [ngStyle]="{
      'visibility':toolbar.progress?'visible':'hidden',
      'background-color': '#d3d3d3',
      'min-height': '6px',
      'max-height': '10px',
      'border-radius': '13px'
    }"
  >
    <progressbar
      class="progress-bar progress-bar-animated bg-indigo"
      role="progressbar"
      [striped]="false"
      [animate]="true"
      [ngStyle]="{
        'background-color': '#9C27B0',
        margin: 0,
        width: progress | percent: '.2',
        height: '10px'
      }"
      attr.aria-valuenow="{{ progress | percent: '.2' }}"
      aria-valuemin="0"
      aria-valuemax="100"
      title="{{ progress | percent: '.1' }}"
      container="body"
    ></progressbar>
  </div>
</ng-template>

<!-- volume slider -->
<ng-template #_volume>
  <div class="col-auto mx-1 px-0"
    [ngStyle]="{'visibility':toolbar.volume?'visible':'hidden'}"
    title="Volume"
  >
    <div class="btn-group" dropdown #dropdown="bs-dropdown">
      <mat-icon
        dropdownToggle
        class="col-auto"
        type="button"
        [ngClass]="volumeClass"
      >{{volumeIcon}}
      </mat-icon>
      <span *dropdownMenu
        class="dropdown-menu material"
        role="menu"
        [ngClass]="{'muted':volume === 0}"
      >
        <input
          id="volume"
          class="dropdown-item"
          role="menuitem"
          type="range"
          min="0"
          max="1"
          step="0.1"
          [(ngModel)]="volume"
          title="{{ volume }}"
        />
      </span>
    </div>
  </div>
</ng-template>
